<template>
  <div class="index">
    <div class="bannercont">
      <div class="banner1" v-show="bannerlist.length > 0">
        <el-carousel :interval="5000" arrow="always" :height="'12.2vw'">
          <el-carousel-item v-for="item in bannerlist" :key="item.id" fit="cover">
            <el-image class="imgg" :src="item.code" @click="goPage(item.value)" />
          </el-carousel-item>
        </el-carousel>
      </div>
      <div class="banner2" v-show="bannerLists.length > 0">
        <el-image v-for="item in bannerLists" :key="item.id" fit="cover" class="imgg" :src="item.code"
          @click="goPage(item.value)" />
      </div>
    </div>
    <div style="margin-top: 15px" class="inputBox">
      <el-input placeholder="请输入公司名称或者职位名称" v-model="seachName" class="input-with-select" @keyup.enter.native="getTopList()">
        <el-cascader slot="prepend" placeholder="请选择职位类型" :options="jobTypeOptions" :show-all-levels="false"
          @change="changejobType" clearable filterable></el-cascader>
        <el-button type="primary" slot="append" icon="el-icon-search" @click="getTopList()"></el-button>
      </el-input>
    </div>
    <div class="workpanel">
      <el-form>
        <el-form-item label="行业类型">
          <el-radio-group @input="goChange" v-model="industry">
            <el-radio v-for="(item, index) in industrySelector" :key="`is` + index" :label="item.value"></el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="排序类型">
          <el-radio-group @input="goChange" v-model="sort">
            <el-radio label="time">时间排序</el-radio>
            <el-radio label="commission">佣金排序</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="职位特性">
          <el-checkbox-group @change="goChange" v-model="labelarray">
            <el-checkbox label="优">优</el-checkbox>
            <el-checkbox label="急">急</el-checkbox>
            <el-checkbox label="独">独</el-checkbox>
            <el-checkbox label="友单">友单</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-collapse v-model="activeNames">
          <el-collapse-item title="更多筛选项" name="1">
            <el-form-item label="年限范围（万元）">
              <el-radio-group @input="goChange" v-model="yearSalary">
                <el-radio label="0">不限</el-radio>
                <el-radio label="1">30以下</el-radio>
                <el-radio label="2">30~50</el-radio>
                <el-radio label="3">50~80</el-radio>
                <el-radio label="4">80~150</el-radio>
                <el-radio label="5">150~300</el-radio>
                <el-radio label="6">300以上</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="职位情况">
              <el-radio-group @input="goChange" v-model="jobPosition">
                <el-radio label="0">不限</el-radio>
                <el-radio label="新增职位">新增职位</el-radio>
                <el-radio label="替补职位">替补职位</el-radio>
                <el-radio label="空缺职位">空缺职位</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="职位保证期">
              <el-radio-group @input="goChange" v-model="warranty">
                <el-radio label="0">不限</el-radio>
                <el-radio label="一个月">一个月</el-radio>
                <el-radio label="两个月">两个月</el-radio>
                <el-radio label="三个月">三个月</el-radio>
                <el-radio label="四个月">四个月</el-radio>
                <el-radio label="五个月">五个月</el-radio>
                <el-radio label="六个月">六个月</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="热门城市">
              <el-radio-group @input="goChange" v-model="adderCode">
                <el-radio v-for="(item, index) in cityArray" :key="`city` + index" :label="item.code">{{ item.value
                }}</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-collapse-item>
        </el-collapse>
      </el-form>
    </div>
    <div class="workpanel" style="padding: 20px 30px">
      <div class="sortBox">
        <div :class="sort === 'time' ? 'sortitem active' : 'sortitem'" @click="setSort('time')">时间排序</div>
        <i v-if="sort === 'time' && sortType === 'desc'" class="el-icon-bottom" @click="setSortType('asc')"></i>
        <i v-if="sort === 'time' && sortType === 'asc'" class="el-icon-top" @click="setSortType('desc')"></i>
        <div :class="sort === 'commission' ? 'sortitem active' : 'sortitem'" @click="setSort('commission')">佣金排序</div>
        <i v-if="sort === 'commission' && sortType === 'desc'" class="el-icon-bottom"  @click="setSortType('asc')"></i>
        <i v-if="sort === 'commission' && sortType === 'asc'" class="el-icon-top" @click="setSortType('desc')"></i>
        <div class="sortitem">共 {{ total }}个职位</div>
      </div>
    </div>
    <div class="listbox">
      <div class="jobitem" v-for="(item, key) in jobList" :key="'job' + key" @click="goJobInfo(item.id)">
        <div class="box1">
          <div class="line1">{{ item.positionName }}</div>
          <div class="line2">
            <span><i class="el-icon-money"></i>{{ item.minYearSalary + '~' + item.maxYearSalary + 'w' }}</span>
            <span><i class="el-icon-map-location"></i>{{ item.workPlace ? item.workPlace + ',' : '' }}{{ item.cityName
            }}</span>
            <span><i class="el-icon-s-opportunity"></i>{{ item.minEducation }}</span>
            <span><i class="el-icon-alarm-clock"></i>{{ item.workingLifeMin + '~' + item.workingLifeMax +
              '年' }}</span>
            <span><i class="el-icon-user"></i>{{ item.recruitsNumber + '人' }}</span>
            <span><i class="el-icon-suitcase"></i>{{ item.industry }}</span>
          </div>
          <div class="line3">
            <div><span>佣金:</span>{{ Number(
              ((((Number(item.salaryMax) +
                Number(item.salaryMin)) *
                9) /
                100) *
                Number(70)) /
              100
            ).toFixed(2) + 'w' }}</div>
            <div><span>分成:</span>{{ item.commissionRate }}%</div>
            <div><span>保证期:</span>{{ item.warranty }}</div>
            <div><span>付款细则:</span>{{ item.payRules }}</div>
            <div><span>更新日期:</span>{{ moment(item.updateTime).format('YYYY-MM-DD') }}</div>
          </div>
        </div>
        <div class="box3">
          <div class="rightbox">
            <div v-if="Number(item.isCompany) === 0" class="cname">{{ item.customCompanyName }}</div>
            <div v-if="Number(item.isCompany) === 1" class="cname">{{ item.companyNameCustom ? item.companyNameCustom :
              '某公司' }}</div>
            <div v-if="item.tagss && item.tagss.length > 0" class="tagbox">
              <el-tag style="margin-left: 10px" v-for="(itemg, indexs) in (item.tagss)" :key="indexs"
                :type="tagstyle[indexs]">{{ itemg }}</el-tag>
            </div>
          </div>
          <el-image class="avater" fit="contain"
            v-if="Number(item.isCompany) === 0 && item.customCompanyLogo !== '' && item.customCompanyLogo !== undefined && item.customCompanyLogo !== null"
            :src="item.customCompanyLogo"></el-image>
          <el-avatar
            v-if="Number(item.isCompany) === 0 && (item.customCompanyLogo === '' || item.customCompanyLogo === undefined || item.customCompanyLogo === null)">
            {{ item.customCompanyName }} </el-avatar>
          <el-avatar v-if="Number(item.isCompany) === 1"> {{ item.companyNameCustom ? item.companyNameCustom : '某公司' }}
          </el-avatar>
        </div>
      </div>
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageNumber"
        :page-sizes="[15, 30, 50, 100]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>

  </div>
</template>

<script>
import axios from 'axios'
import Config from '../config/index'
import moment from 'moment'

export default {
  name: 'index',
  props: {},
  data() {
    return {
      bannerlist: [],
      bannerLists: [],
      Number: Number,
      moment: moment,
      jlList: [],
      industrySelector: [],
      industryCode: '',
      cityArray: [],
      selectcityArray: {
        id: '1',
        code: '',
        value: '不限制',
      },
      seachName: '',
      jobTypeOptions: [],
      jobTypeCode: '',
      jobType: '',
      industry: '全部行业',
      jobName: '全部职位',
      sort: 'time',
      sortType: 'desc',
      labelarray: [],
      yearSalary: '0',
      searlyYearArray: [
        {
          min: '',
          max: '',
          label: '不限',
          id: '1',
        },
        {
          min: '',
          max: 30,
          label: '30以下',
          id: '2',
        },
        {
          min: 30,
          max: 50,
          label: '30-50',
          id: '3',
        },
        {
          min: 50,
          max: 80,
          label: '50~80',
          id: '4',
        },
        {
          min: 80,
          max: 150,
          label: '80~150',
          id: '5',
        },
        {
          min: 150,
          max: 300,
          label: '150~300',
          id: '6',
        },
        {
          min: 300,
          max: '',
          label: '300以上',
          id: '7',
        },
      ],
      jobPosition: '0',
      warranty: '0',
      adderCode: '',
      activeNames: ['0'],
      jobList: [],
      jobLength: 0,
      pageNumber: 1,
      pageSize: 15,
      pagees: 1,
      total: 0,
      tagstyle: [
        'success',
        'info',
        'warning',
        'danger'
      ],
    }
  },
  watch: {},
  created: function () { },
  methods: {
    setSort: function (type) {
      this.sort = type
      this.pageNumber = 1
      this.pageSize = 15
      this.pagees = 1
      this.getTopList()
    },
    setSortType: function (type) {
      this.sortType = type
      this.pageNumber = 1
      this.pageSize = 15
      this.pagees = 1
      this.getTopList()
    },
    goPage: function (url) {
      window.open(url, '_blank')
    },
    getBannerList: function () {
      let that = this
      axios({
        method: 'GET',
        url: Config.path + '/api/common/dict/getDictlist?type=banner_ca_da',
        headers: {
          token: localStorage.getItem('token'),
          'content-type': 'application/json'
        }
      }).then((res) => {
        if (res.data.success === '1') {
          let demoList = res.data.content
          that.bannerlist = demoList
        } else {
          that.$message.error(res.data.message);
        }
      }).catch((err) => {
        that.$message.error('无法连接网络,请检查WiFi或移动数据网络是否正常');
      })
    },
    getSmallBanner: function () {
      let that = this
      axios({
        method: 'GET',
        url: Config.path + '/api/common/dict/getDictlist?type=banner_ca_x',
        headers: {
          token: localStorage.getItem('token'),
          'content-type': 'application/json'
        }
      }).then((res) => {
        if (res.data.success === '1') {
          let demoList = res.data.content
          that.bannerLists = demoList
        } else {
          that.$message.error(res.data.message);
        }
      }).catch((err) => {
        that.$message.error('无法连接网络,请检查WiFi或移动数据网络是否正常');
      })
    },
    getTopList: function () {
      let that = this
      that.loading = true
      let data = {
        pageSize: that.pageSize,
        pageNum: that.pageNumber,
        sort: that.sort,
        sortType: that.sortType
      }
      if (that.seachName !== '') {
        data.keyword = that.seachName
      }
      if (that.industry !== '' && that.industry !== '全部行业') {
        data.industry = that.industry
      }

      if (that.jobTypeCode !== '') {
        data.jobTypeCode = that.jobTypeCode
      }
      if (that.labelarray.length > 0) {
        data.label = that.labelarray.join('、')
      }
      if (that.yearSalary !== '0') {
        data.maxYearSalary = that.searlyYearArray[Number(that.yearSalary)].max
        data.minYearSalary = that.searlyYearArray[Number(that.yearSalary)].min
      }
      if (that.jobPosition !== '0') {
        data.jobPosition = that.jobPosition
      }
      if (that.warranty !== '0') {
        data.warranty = that.warranty
      }
      if (that.adderCode !== '') {
        data.adderCode = that.adderCode
      }
      axios({
        method: 'POST',
        url: Config.path + '/api/candidate/getjobList',
        headers: {
          token: localStorage.getItem('token'),
          'content-type': 'application/json',
        },
        data: data,
      })
        .then((res) => {
          that.loading = false
          that.getJobLength()
          if (res.data.success === '1') {
            let demoList = res.data.content.list
            for (let item in demoList) {
              var a = moment()
              var b = moment(demoList[item].createTime)
              if (a.diff(b, 'days') >= 1) {
                if (
                  moment(demoList[item].createTime).format('YYYY') ===
                  moment().format('YYYY')
                ) {
                  demoList[item].xsTime =
                    moment(demoList[item].createTime).format('MM月DD日') + ' '
                } else {
                  demoList[item].xsTime =
                    moment(demoList[item].createTime).format('YYYY年MM月DD日') +
                    ' '
                }
              } else if (a.diff(b, 'hours') >= 1) {
                demoList[item].xsTime = a.diff(b, 'hours') + '小时前 '
              } else if (a.diff(b, 'minutes') >= 1) {
                demoList[item].xsTime = a.diff(b, 'minutes') + '分钟前 '
              } else {
                demoList[item].xsTime = '刚刚 '
              }
              let zjNx =
                ((Number(demoList[item].salaryMax) +
                  Number(demoList[item].salaryMin)) *
                  12) /
                10 /
                2
              for (let m in that.jlList) {
                if (
                  zjNx <= Number(that.jlList[m].maxYearSalary) &&
                  zjNx > Number(that.jlList[m].minYearSalary)
                ) {
                  demoList[item].jlItem = that.jlList[m]
                }
              }
              if (demoList[item].label) {
                demoList[item].tagss = demoList[item].label.split(':')
              }
            }
            that.pagees = res.data.content.pages
            that.total = res.data.content.total
            that.jobList = demoList
          } else {
            that.$message.error(res.data.message)
          }
        })
        .catch((err) => {
          

          that.loading = false
          that.$message.error('无法连接网络,请检查WiFi或移动数据网络是否正常')
        })
    },
    getJobLength: function () {
      let that = this
      axios({
        method: 'POST',
        url: Config.path + '/api/candidate/getjobCount',
        headers: {
          token: localStorage.getItem('token'),
          'content-type': 'application/json'
        }
      }).then((res) => {
        if (res.data.success === '1') {
          that.jobLength = res.data.content
        } else {
          that.$message.error(res.data.message);
        }
      }).catch((err) => {
        that.$message.error('无法连接网络,请检查WiFi或移动数据网络是否正常');
      })
    },
    getJlList: function () {
      let that = this
      that.loading = true
      let data = {}
      axios({
        method: 'POST',
        url: Config.path + '/api/candidate/getlotterDrawList',
        headers: {
          token: localStorage.getItem('token'),
          'content-type': 'application/json',
        },
        data: data,
      })
        .then((res) => {
          that.loading = false
          if (res.data.success === '1') {
            that.jlList = res.data.content
          } else {
            that.$message.error(res.data.message)
          }
        })
        .catch((err) => {
          that.loading = false
          that.$message.error('无法连接网络,请检查WiFi或移动数据网络是否正常')
        })
    },
    getHyList: function () {
      let that = this
      that.loading = true
      axios({
        method: 'GET',
        url: Config.path + '/api/common/dict/getlist?type=jobType',
        headers: {
          token: localStorage.getItem('token'),
          'content-type': 'application/json',
        },
      })
        .then((res) => {
          that.loading = false
          if (res.data.success === '1') {
            that.industrySelector = [
              {
                code: '',
                value: '全部行业',
              },
            ].concat(res.data.content)
            that.industry = '全部行业'
            that.industryCode = ''
          } else {
            that.$message.error(res.data.message)
          }
        })
        .catch((err) => {
          that.loading = false
          that.$message.error('无法连接网络,请检查WiFi或移动数据网络是否正常')
        })
    },
    getHotCityList: function () {
      let that = this
      that.loading = true
      axios({
        method: 'GET',
        url: Config.path + '/api/common/dict/getlist?type=hotCity',
        headers: {
          token: localStorage.getItem('token'),
          'content-type': 'application/json',
        },
      })
        .then((res) => {
          that.loading = false
          if (res.data.success === '1') {
            that.cityArray = [
              {
                id: '1',
                code: '',
                value: '不限制',
              },
            ].concat(res.data.content)
          } else {
            that.$message.error(res.data.message)
          }
        })
        .catch((err) => {
          that.loading = false
          that.$message.error('无法连接网络,请检查WiFi或移动数据网络是否正常')
        })
    },
    getJobTypeArray: function () {
      let that = this
      that.loading = true
      axios({
        method: 'GET',
        url: Config.path + '/api/common/treedata/gettreeData',
        headers: {
          token: localStorage.getItem('token'),
          'content-type': 'application/json',
        },
      })
        .then((res) => {
          that.loading = false
          if (res.data.success === '1') {
            that.gsArray(res.data.content)
          } else {
            that.$message.error(res.data.message)
          }
        })
        .catch((err) => {
          that.loading = false
          that.$message.error('无法连接网络,请检查WiFi或移动数据网络是否正常')
        })
    },
    gsArray: function (list) {
      for (let i in list) {
        let item = list[i]
        item.label = item.name
        item.value = item.name + ',' + item.code
        if (item.childrenlist) {
          item.children = item.childrenlist
          for (let j in item.children) {
            let item2 = item.children[j]
            item2.label = item2.name
            item2.value = item2.name + ',' + item2.code
            if (item2.childrenlist) {
              item2.children = item2.childrenlist
              for (let k in item2.children) {
                let item3 = item2.children[k]
                item3.label = item3.name
                item3.value = item3.name + ',' + item3.code
              }
            }
          }
        }
      }
      this.jobTypeOptions = list
    },
    changejobType: function (e) {
      if (e.length > 0) {
        this.jobTypeCode = e[e.length - 1].split(',')[1]
        this.jobType = e[e.length - 1].split(',')[0]
      } else {
        this.jobTypeCode = ''
        this.jobType = ''
      }
      this.pageNumber = 1
      this.pageSize = 15
      this.pagees = 1
      this.getTopList()
    },
    goChange: function () {
      this.pageNumber = 1
      this.pageSize = 15
      this.pagees = 1
      this.getTopList()
    },
    handleCurrentChange: function (e) {
      this.pageNumber = e
      this.getTopList()
    },
    handleSizeChange: function (e) {
      this.pageNumber = 1
      this.pageSize = e
      this.pagees = 1
      this.getTopList()
    },
    goJobInfo: function (id) {
      

      this.$router.push({
        name: 'job',
        params: { id }
      })
    }
  },
  mounted: function () {
    let that = this
    that.getJlList()
    that.getHyList()
    that.getHotCityList()
    that.getJobTypeArray()
    that.getTopList()
    that.getBannerList()
    that.getSmallBanner()
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style lang="scss">
.index {
  width: 100%;
  flex: 1;
  padding-top: 1px;
  position: relative;
  background-color: #e6e6e6;
  padding-bottom: 100px;
  


  .el-collapse{
    .el-icon-arrow-right{
      transform: rotate(90deg)
    }
    .el-collapse-item__header{
      .is-active{
        transform: rotate(-90deg)
      }
    }

  }

  .bannercont {
    width: 100vw;

    .banner1 {
      width: 70vw;
      height: 12.2vw;
      margin: 20px auto 0 auto;

      .imgg {
        width: 70vw;
        height: 12.2vw;
      }
    }

    .banner2 {
      width: 70vw;
      height: 6.2vw;
      margin: 20px auto 0 auto;
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: center;

      .imgg {
        width: 16.3vw;
        height: 5.05vw;
        margin-right: 1vw;
      }
    }
  }




  .inputBox {
    width: 70vw;
    margin: 0 auto;
    overflow: hidden;

    .el-input-group {
      background: #fff;
      height: 80px;

      .el-input-group__prepend {
        width: 200px;
        background: transparent;
        padding: 0;
        border: none;

        .el-cascader {
          .el-input {
            height: 40px;

            .el-input__inner {
              border: none;
            }
          }
        }
      }

      &>.el-input__inner {
        border: none;
        height: 80px;
        font-size: 18px;
      }

      .el-input__inner {
        font-size: 18px;
      }

      .el-input-group__append {
        height: 100%;
        border: none;
        cursor: pointer;
        width: 50px;
        background: #5DC1CF;
        .el-button{
          margin: 0 auto;
          color: #fff;
          font-size: 20px;
        }
      }
    }
  }

  .workpanel {
    width: 70vw;
    margin: 30px auto 0 auto;
    padding: 30px;
    background: #fff;
    box-sizing: border-box;


    .sortBox {
      display: flex;
      flex-direction: row;
      justify-content: flex-end;
      align-content: center;

      .sortitem{
        line-height: 20px;
        margin-left: 20px;
        cursor: pointer;
      }

      .active{
        color: #5DC1CF;
      }

      i{
        color: #5DC1CF;
        line-height: 20px;
        cursor: pointer;
      }
    }

    .el-form {
      .el-form-item {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: flex-start;
        margin-bottom: 10px;

        .el-form-item__label {
          width: 160px;
          text-align: left;
          line-height: 40px;
        }

        .el-form-item__content {
          flex: 1;

          .el-radio-group {
            .el-radio {
              line-height: 40px;
              margin: 0px 20px 10px 0px;
            }
          }
        }
      }
    }
  }

  .listbox {
    width: 70vw;
    margin: 30px auto 0 auto;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;

    .jobitem {
      width: 100%;
      border-radius: 10px;
      background-color: #fff;
      box-sizing: border-box;
      padding: 30px;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 20px;
      cursor: pointer;

      .box1 {
        .line1 {
          color: #5DC1CF;
          font-size: 18px;
        }

        .line2 {
          display: flex;
          flex-direction: row;
          justify-content: flex-start;
          align-items: flex-start;
          margin-top: 10px;
          color: #a3a3a3;

          span {
            i {
              margin-right: 5px;
            }

            margin-right: 20px;
          }
        }

        .line3 {
          display: flex;
          flex-direction: row;
          justify-content: flex-start;
          align-items: flex-start;
          margin-top: 10px;
          color: #606060;

          div {
            span {
              margin-right: 5px;
            }

            margin-right: 20px;
          }
        }
      }


      .box3 {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;

        .el-avatar {
          position: relative !important;
          top: 0 !important;
          right: 0 !important;
          width: 40px !important;
          height: 40px !important;
        }

        .el-image {
          position: relative !important;
          top: 0 !important;
          right: 0 !important;
          width: 40px !important;
          height: 40px !important;
        }

        .rightbox {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          align-items: flex-end;
          margin-right: 30px;

          .cname {}

          .tagbox {
            margin-top: 30px;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
          }
        }
      }
    }
  }
}
</style>
